import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Disabled, DisabledButton } from "../../../../Constant";
import { DISABLE_BUTTONS_LIST, DISABLE_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import { Btn } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";

const FlatDisabledButtons = () => {
  return (
    <Card>
      <CommonCardHeader title={DisabledButton} span={DISABLE_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn disabled color="primary" className="btn-square">{Disabled}</Btn>
        {DISABLE_BUTTONS_LIST.map((data, index) => (
          <CommonFlateButton key={index} item={data} disabled={true} />
        ))}
      </CardBody>
    </Card>
  );
};

export default FlatDisabledButtons;
